export enum TipoCheckLimitEnum {
  TEMPORADA = "COMPROBAR LIMITE DURANTE TEMPORADA",
  CONTINUO = "COMPROBAR LIMITE DURANTE CONTINUO",
  PATRON = "COMPROBAR LIMITE EN PATRON"
}